var map = {
	"./batscop": 9,
	"./batscop.gif": 9,
	"./icons/left-arrow": 10,
	"./icons/left-arrow-double": 11,
	"./icons/left-arrow-double.svg": 11,
	"./icons/left-arrow.svg": 10,
	"./icons/right-arrow": 12,
	"./icons/right-arrow-double": 13,
	"./icons/right-arrow-double.svg": 13,
	"./icons/right-arrow.svg": 12,
	"./logo": 14,
	"./logo.png": 14,
	"./mailer/logo": 15,
	"./mailer/logo.png": 15
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;